export default __webpack_public_path__ + "static/media/CEDIA-claro-para-chacra.d6ba7d92.jpg";